import "./App.scss";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Result, Button, Layout, BackTop } from "antd";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { ErrorBoundary } from "react-error-boundary";

import { useAppSelector } from "store/hook";

import { NavRoutes } from "Components/Navbar/navRoutes";
import Nav from "./Components/Navbar";
import Login from "Components/Login";
import Header from "./Components/Header";
import WrongPage from "./Pages/WrongPage";
import InternalError from "./Pages/WrongPage/InternalFail";
import IoTGuage from "./Pages/Dashboard/IoTGuage";
import Go from "./Components/Go";

// Protect Routes
import PrivateRoutes from "Utility/PrivateRoutes";
import { useEffect, useState } from "react";
import { ensureCsrf, getCookie, initCsrf } from "Utility/Service";

const { Content } = Layout;

// 定義 FallbackProps
interface FallbackProps {
  // 這是一個表示錯誤的對象，包含錯誤的詳細信息。
  error: Error;
  resetErrorBoundary: (...args: Array<unknown>) => void;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: false,
    },
  },
});

const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  console.log("ErrorFallback", error);
  return (
    <Result
      status="500"
      title="Error"
      subTitle="Sorry, something went wrong."
      extra={
        <Button type="primary" onClick={resetErrorBoundary}>
          Go Back
        </Button>
      }
    />
  );
};

const App = () => {
  const { isLogin } = useAppSelector((state) => state.global);
  useEffect(() => {
    ensureCsrf().catch(console.error);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Layout style={{ minHeight: "100vh" }}>
          <Nav />
          <Layout className="site-layout">
            <Header />
            <Content style={{ margin: "6px 16px" }}>
              <ErrorBoundary
                FallbackComponent={ErrorFallback}
                onReset={() => {
                  window.location.reload();
                }}
              >
                <BackTop visibilityHeight={100} />

                <Routes>
                  {/* 主要路由設定：如果已登入，則渲染 PrivateRoutes 中的內容 */}
                  <Route element={<PrivateRoutes />}>
                    {/* 當 URL 路徑為 "/iotguage" 時，渲染 <IoTGuage /> 元件 */}
                    <Route path="/iotguage" element={<IoTGuage />}></Route>
                    {/* 當 URL 路徑為 "/internalerror" 時，渲染 <InternalError /> 元件 */}
                    <Route path="/internalerror" element={<InternalError />}></Route>
                    {/* 導航列 */}
                    {NavRoutes.map((item, index) => (
                      // 動態生成導航列相關的路由配置
                      // 路由的 path 由 NavRoutes 中的 item.path 決定，對應的元件由 item.component 決定
                      // 每個路由都有唯一的 key 以防止 React 中的重複渲染
                      <Route key={index} path={item.path} element={<item.component key={Date.now()} />} />
                    ))}
                  </Route>
                  {/* caseSensitive：它指定路由是否區分大小寫 */}
                  <Route caseSensitive path="/osmartGO/:ticket" element={<Go />} />

                  <Route path="/userlogin" element={<Login />}></Route>

                  {isLogin ? (
                    <Route path="*" element={<WrongPage />}></Route>
                  ) : (
                    <Route path="*" element={<Login />}></Route>
                  )}
                </Routes>
              </ErrorBoundary>
            </Content>
          </Layout>
        </Layout>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default App;
